module.exports = __webpack_public_path__ + "img/national-grid-map.jpg";